import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Input,
  Select,
  InputNumber,
  DatePicker,
  Button,
  message,
} from "antd";
import {
  UserOutlined,
  ClusterOutlined,
  AppstoreOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import { useNavigate } from "react-router-dom";
const { RangePicker } = DatePicker;


import dayjs from "dayjs";
export default function LicenseForm() {
  const [form] = Form.useForm();
  const [module, setModule] = useState();
    const [mode, setMode] = React.useState("lifetime");
  // const [moduleList, setModuleList] = useState();
  
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const navigate= useNavigate()
    const [moduleList, setModuleList] = useState([

    {
        "value": "Water",
        "label": "Water"
    },
    {
        "value": "Steam",
        "label": "Steam"
    },
    {
        "value": "Air",
        "label": "Air"
    },
    {
        "value": "Gas",
        "label": "Gas"
    },
        {
        "value": "Electrical",
        "label": "Electrical"
    },

]);
  const onSubmit = (values) => {
    // console.log("Form Submitted:", values);
    // console.log(values.modules.join(","))
    const [fromDate, toDate] = values.timePeriod;

    // console.log("From Date:", fromDate.format("YYYY-MM-DD"));
    // console.log("To Date:", toDate.format("YYYY-MM-DD"));

    console.log("All Values:", values);
    const body = {
      clID: 1,
      clientName: String(values.clientName) || "",
      noOfGateWays: String(values.gateways) || '',
      noOfMeters: values.meters || 0,
      modules: values.modules ? values.modules.join(",") : "",
      startDate: fromDate.format("YYYY-MM-DD"),
      endDate: toDate.format("YYYY-MM-DD"),
    };
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.INSERT_LICENSE_DETAILS}`,
      body: body,
    }).then((res) => {
      console.log(res);
      if(res &&res.includes("Successfully")){
        navigate("/login");
         message.success(` ${res}`);
        }else{
          message.error(` ${res}`);
        }
    });
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.FLOW_MODULES}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        const data = res.map((i) => ({
          value: i.moduleName,
          label: i.moduleName,
        }));
        // setModuleList(data);
        setModule(moduleList[0]?.value);
      }
    });
  }, []);
  useEffect(()=>{
    handlePeriodChange(mode)
  },[])
  const handlePeriodChange = (value) => {
    setMode(value);

    if (value === "lifetime") {
      const startDate = dayjs(); 
      const endDate = dayjs().add(10, "year"); 

      form.setFieldsValue({
        timePeriod: [startDate, endDate],
      });
    } else {
      form.setFieldsValue({
        timePeriod: null,
      });
    }
  };
  return (
    <div className="flex justify-center  items-center p-6 bg-white h-screen">
      <Card
        hoverable
        title={
          <span className="text-lg font-semibold"> License Information</span>
        }
        className="w-full max-w-3xl shadow-lg rounded-xl border border-gray-100 dark:border-gray-200 h-fit"
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onSubmit}
          className="space-y-3"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Client Name */}
            <Form.Item
              label={<span className="text-sm font-medium">Client Name</span>}
              name="clientName"
              rules={[{ required: true, message: "Please enter client name" }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Enter client name"
                className="rounded-lg"
              />
            </Form.Item>
            {/* No. Gateways */}
            <Form.Item
              label={
                <span className="text-sm font-medium">No. of Gateways</span>
              }
              name="gateways"
              rules={[{ required: true, message: "Enter number of gateways" }]}
            >
              <InputNumber
                min={0}
                className="w-full rounded-lg"
                placeholder="0"
                prefix={<ClusterOutlined />}
              />
            </Form.Item>
          </div>

          {/* Number Fields in Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* No. Meters */}
            <Form.Item
              label={<span className="text-sm font-medium">No. of Meters</span>}
              name="meters"
              rules={[{ required: true, message: "Enter number of meters" }]}
            >
              <InputNumber
                min={0}
                className="w-full rounded-lg"
                placeholder="0"
              />
            </Form.Item>

            {/* Modules */}
            <Form.Item
              label={<span className="text-sm font-medium">Modules</span>}
              name="modules"
              rules={[{ required: true, message: "Select modules" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select modules"
                suffixIcon={<AppstoreOutlined />}
                className="rounded-lg"
                options={moduleList}
                value={module}
              />
            </Form.Item>
          </div>

          {/* Time Period */}
          {/* <Form.Item
            label={
              <span className="text-sm font-medium">License Time Period</span>
            }
            name="timePeriod"
            rules={[{ required: true, message: "Select time period" }]}
          >
            <RangePicker
              className="w-full rounded-lg"
              suffixIcon={<CalendarOutlined />}
            />
          </Form.Item> */}
           <Form.Item
        label={<span className="text-sm font-medium">License Type</span>}
        name="periodType"
        rules={[{ required: true, message: "Select license type" }]}
      >
        <Select
          placeholder="Select License Type"
          onChange={handlePeriodChange}
          defaultValue={"lifetime"}
        >
          <Option value="lifetime">Life Time</Option>
          <Option value="custom">Custom</Option>
        </Select>
      </Form.Item>
{  <Form.Item
        label={
          <span className="text-sm font-medium">
            License Time Period
          </span>
        }

        name="timePeriod"
        rules={[{ required: true, message: "Select time period" }]}
      >
        <RangePicker
          className="w-full rounded-lg"
          suffixIcon={<CalendarOutlined />}
          disabled={mode === "lifetime"}
        />
      </Form.Item>}
      {/* Date Range */}
    

          {/* Submit Button */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full py-0 rounded-lg text-lg font-semibold shadow-md hover:scale-[1.02] transition-transform"
            >
              Save License
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
